import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from "@/shared/hooks";
import { SALUTATION } from "@/types";
import { getFeaturesEnabled } from "@/utils/getFeaturesEnabled";
import { RadioGroup } from "@gemini/ui";
import { useEffect } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { salutationInputTestId } from "./constants";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
export const SalutationInput = ({ control, required }) => {
    const { t } = useI18n();
    const { setValue } = useFormContext();
    const { hideSalutationField } = getFeaturesEnabled();
    const isPreviewMode = useIsPreviewMode();
    useEffect(() => {
        // Ensure the salutation field is set when hideSalutationField feature is enabled,
        // since the field is not rendered and would otherwise remain unset in the form context.
        if (hideSalutationField) {
            setValue("salutation", SALUTATION.DIVERSE);
        }
    }, [setValue, hideSalutationField]);
    if (hideSalutationField)
        return;
    return (_jsx(Controller, { name: "salutation", control: control, render: ({ field: { value, onChange, name }, fieldState: { error } }) => {
            return (_jsx(RadioGroup, { testId: salutationInputTestId, hasNecessityIndicator: required, direction: "horizontal", onChange: onChange, isDisabled: isPreviewMode, value: value, items: [
                    {
                        value: SALUTATION.MR,
                        label: t("contact.form.salutation_he"),
                    },
                    {
                        value: SALUTATION.MRS,
                        label: t("contact.form.salutation_she"),
                    },
                    {
                        value: SALUTATION.DIVERSE,
                        label: t("contact.form.salutation_diverse"),
                    },
                ], label: t("contact.form.salutation"), error: error === null || error === void 0 ? void 0 : error.message, name: name }));
        } }));
};
